import React from 'react';
import './styles.css';

export default function Footer(){
    return(
        <footer>
            <p>Copyright © {new Date().getFullYear()} <b>Brian Mello design Limited.</b></p>
        </footer>
    )
}